import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './page.scss';

const Page = ({ className, noSpacing, children }) =>
  <div className={classNames(styles.container, { [styles.noSpacing]: noSpacing }, className)}>
    {children}
  </div>;

Page.propTypes = {
  className: PropTypes.string,
  noSpacing: PropTypes.bool,
  children: PropTypes.node,
};

export default Page;



// WEBPACK FOOTER //
// ./app/components/page/page.js